import { PRICE_SEPARATOR_URL } from "../../constants/filterOptions";

export const encodeValues = (decodedValues: {
  [key: string]: string | string[];
}) => {
  const encodedValues = { ...decodedValues };
  Object.keys(encodedValues).forEach((key) => {
    if (encodedValues[key] instanceof Array) {
      encodedValues[key] = [];
      (decodedValues[key] as string[]).forEach((value) => {
        (encodedValues[key] as string[]).push(encodeURI(value));
      });
    } else {
      encodedValues[key] = encodeURI(decodedValues[key] as string);
    }
  });
  return encodedValues;
};

export const decodeParams = (params: string | string[]) =>
  params instanceof Array
    ? params.map((value) => decodeURI(value))
    : decodeURI(params as string);

export const decodePrice = (price: string) => {
  try {
    const isRange = price.includes(PRICE_SEPARATOR_URL);

    if (isRange) {
      const [min, max] = price.split(PRICE_SEPARATOR_URL);
      return [min, max];
    }
    return [price];
  } catch (error) {
    console.error(error);
    return ["0"];
  }
};
